import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=dbf923c0&scoped=true&"
import script from "./CandidateInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateInfo.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInfo.vue?vue&type=style&index=0&id=dbf923c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf923c0",
  null
  
)

export default component.exports